<template>
  <li @click.stop="select" @mouseout.stop="blur" v-show="!hidden" :class="classes">
    <slot>{{ showLabel }}</slot>
  </li>
</template>
<script>
  import Emitter from "../../mixins/emitter";
  const prefixCls = "f-select-item";
  export default {
    name: "uOption",
    componentName: "select-item",
    mixins: [Emitter],

    props: {
      value: {
        type: [String, Number],
        required: true
      },
      label: {
        type: [String, Number]
      },
      disabled: {
        type: Boolean,
        default: false
      }
    },
    data() {
      return {
        selected: false,
        index: 0, 
        isFocus: false,
        hidden: false, 
        searchLabel: "" 
      };
    },
    computed: {

      showLabel() {
        return this.label ? this.label : this.value;
      },
      classes() {
        return [
        `${prefixCls}`,
        {
          [`${prefixCls}-disabled`]: this.disabled,
          [`${prefixCls}-selected`]: this.selected,
          [`${prefixCls}-focus`]: this.isFocus
        }
        ];
      },
    },
    methods: {
      select() {
        if (this.disabled) {
          return false;
        }
        this.dispatch("uSelect", "on-select-selected", this.value);
      },
      blur() {
        this.isFocus = false;
      },
      queryChange(val) {
        const parsedQuery = val.replace(
          /(\^|\(|\)|\[|\]|\$|\*|\+|\.|\?|\\|\{|\}|\|)/g,
          "\\$1"
          );
        this.hidden = !new RegExp(parsedQuery, "i").test(this.searchLabel);
      }
    },
    mounted() {
      this.searchLabel = this.$el.innerHTML;
      this.$on("on-select-close", () => {
        this.isFocus = false;
      });
      this.$on("on-query-change", val => {
        this.queryChange(val);
      });
    },
    beforeDestroy() {
      this.dispatch("uSelect", "remove");
    }
  };
</script>



// WEBPACK FOOTER //
// src/components/uselect/uOption.vue